<template>
    <li
        :class="[
            'cz2__group-ordering-section',
            isOpen ? 'cz2__group-ordering-section--open' : '',
            isStacked ? 'cz2__group-ordering-section--stacked' : '',
        ]"
    >
        <div class="cz2__group-ordering-main">

            <!-- Mobile - Row 1 -->
            <div class="cz2__group-ordering-top">
                <!-- Order -->
                <div class="cz2__group-section-order cz2__type__small-header">{{order}}.</div>

                <!-- Title -->
                <div class="cz2__group-section-title cz2__type__small-header">
                    {{title}}
                    <!-- Indicator Value -->
                    <span
                        class="cz2__group-section-indicator-value cz2__type__small-header"
                        v-if="!isNaN(indicatorValue)"
                    >
                        {{indicatorValue}}
                    </span>
                </div>

                <!-- Mobile Expand -->
                <button
                    class="cz2__group-section-mobile-expand"
                    @click="toggleOpen"
                >
                    <span class="cz2__group-section-mobile-expand__inner"></span>
                </button>
            </div>

            <!-- Subtitle -->
            <div class="cz2__group-section-subtitle cz2__type__tiny" v-if="subtitle">{{subtitle}}</div>

        </div>

        <!-- Content -->
        <div class="cz2__group-section_content">
            <slot></slot>
        </div>
    </li>
</template>

<style lang="scss">
    @import "../style/variables.scss";

    $ordinalWidth: 18px;
    $mobileButtonHeight: 22px; // same as line height on title
    $mobileIconHeight: 8px;
    $mobileIconWidth: 13px;

    #cz2.cz2 {
        .cz2__group-ordering-section {
            display: block;
            padding: 21px 0;
            border-bottom: $standard-border;

            &:last-of-type {
                border-bottom: none;
            }
        }

        .cz2__group-ordering-top {
            display: flex;
        }

        .cz2__group-section-order {
            width: $ordinalWidth;
        }

        .cz2__group-section-title {
            flex-grow: 1;
        }

        .cz2__group-section-indicator-value {
            padding-left: 10px;
            font-weight: 700;
        }

        .cz2__group-section-subtitle {
            margin-top: 1px;
        }

        .cz2__group-section-mobile-expand {
            display: flex;
            align-items: center;
            height: 22px;
        }

        .cz2__group-section-mobile-expand__inner {
            width: 13px;
            height: 8px;
            background: transparent url(../assets/arrow-small-down@2x.png) no-repeat center/contain;
        }

        .cz2__group-section-subtitle,
        .cz2__group-section_content {
            display: none;
        }

        // Toggle hide / show
        .cz2__group-ordering-section--open {
            .cz2__group-section-indicator-value {
                display: none;
            }

            .cz2__group-section-mobile-expand__inner {
                transform: rotate(180deg);
            }

            .cz2__group-ordering-main {
                margin-bottom: 20px;
            }

            .cz2__group-section-subtitle,
            .cz2__group-section_content {
                display: block;
            }
        }

        // TODO: this line and below used to be desktop only styles, but due to design change updated
        .cz2__group-ordering-section {
            display: flex;
            justify-content: space-between;

            .cz2__group-section-mobile-expand {
                display: none;
            }

            &.cz2__group-ordering-section--stacked {
                display: block;
            }
        }

        .cz2__group-ordering-section--open {
            .cz2__group-ordering-main {
                margin-bottom: 0;
            }
        }

        .cz2__group-section-indicator-value {
            display: none;
        }

        .cz2__group-section-subtitle {
            padding-left: $ordinalWidth;
        }

    }
</style>

<script>

    export default {
        components: {},
        props: {
            order: {
                type: Number,
            },
            title: {
                type: String,
            },
            subtitle: {
                type: String,
                default: null,
            },
            isStacked: {
                type: Boolean,
                default: false,
            },
            indicatorValue: {
                type: Number,
                default: NaN,
            },
        },
        data() {
            return {
                isOpen: true,
            };
        },
        computed: {},
        methods: {
            /**
             * Toggle the state of the mobile expand
             */
            toggleOpen() {
                this.isOpen = !this.isOpen;
            },
        },
    };
</script>
